<!-- @format -->

<template>
	<el-rate v-model="value" :max="pcProps.maxThreshold" :texts="pcProps.rateTexts?.split(',')" class="rate" />
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';

	interface Props {
		modelValue: number | null;
		pcProps: WidgetConfigType;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: -1, //只有为负数才会触发必填校验
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue === 0 ? 0 : props.modelValue ? +props.modelValue : undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.rate {
		flex-wrap: wrap;
	}
</style>
